import { render, staticRenderFns } from "./PartsSuppliers.vue?vue&type=template&id=363777cf&scoped=true"
import script from "./PartsSuppliers.vue?vue&type=script&lang=js"
export * from "./PartsSuppliers.vue?vue&type=script&lang=js"
import style0 from "./PartsSuppliers.vue?vue&type=style&index=0&id=363777cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363777cf",
  null
  
)

export default component.exports